import { render, staticRenderFns } from "./ConfigAlertAmazonSns.vue?vue&type=template&id=90695abc&"
import script from "./ConfigAlertAmazonSns.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertAmazonSns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports